/**
 * Labstep
 *
 * @module components/OrderRequest/Action/Share
 * @desc Share a orderRequest with all users on the platform
 */

import { EntityActionShare } from 'labstep-web/components/Entity/Action/Share';
import type React from 'react';
import type { OrderRequestActionShareProps } from './types';

export const OrderRequestActionShare: React.FC<
  OrderRequestActionShareProps
> = ({ orderRequest }) => <EntityActionShare entity={orderRequest} />;
